import React, { useState } from "react";
import Context from "../../../../context";
import {
  CustomView,
  CustomModal,
  CustomButton2,
  UserInformation,
} from "../../../../components";

import "./index.sass";
import { useTranslation } from "react-i18next";

const Block = () => {
  const { showModal, setShowModal, isLoading, selectedDriver, blockFunction } =
    React.useContext(Context.DriverScreen);

  const [textArea, setTextArea] = useState<string>("");

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="driver-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "BLOCK"}
        label={t("disApprove")}
      >
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <UserInformation
                name={selectedDriver?.firstName}
                avatar={selectedDriver?.avatar}
                isBlock={
                  !selectedDriver?.driverInformation?.approved?.isApproved
                }
                lastName={selectedDriver?.lastName}
                phoneNumber={selectedDriver?.phoneNumber}
              />
            </CustomView.Column>
            <CustomView.Column
              medium={8}
              className="form-colum dropdown description-input"
            >
              <label className="form-label">{t("description")}</label>
              <textarea
                cols={33}
                rows={3}
                onChange={(e) => setTextArea(e.target.value)}
              >
                {textArea}
              </textarea>
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => setShowModal!("NONE")}
                title={t("cancel")}
                type="danger"
              />
            </CustomView.Column>
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() =>
                  blockFunction!({
                    userId: selectedDriver?._id,
                    userType: "DRIVER",
                    description: textArea,
                  })
                }
                title={t("disApprove")}
              />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default Block;
